import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { DistributionRegionFilterRequest, DistributionRegionSaveRequest, SearchFilterRegionRequest} from '../models/request';
import { DistributionRegionResponse } from '../models/response';
import { IDistributionRegionApi } from './base';
import { PaginationResponse } from '@/main/models/common/paginationResponse';

const baseRoute: string = 'DistributionRegion';

export class DistributionRegionApi extends IDistributionRegionApi {
  getDistributions(request: DistributionRegionFilterRequest): Promise<AxiosResponse<Result<DistributionRegionResponse[]>>> {
      return api.get(`${baseRoute}`, {params: request});
  }
  
  getDomain(request: DistributionRegionFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getDistributionRegionPublic(guidCountry: string): Promise<AxiosResponse<Result<DistributionRegionResponse[]>>> {
    return api.get(`${baseRoute}/getdistributionregion_public`, {params: { guidCountry }});
  }

  searchGrid(request: SearchFilterRegionRequest) : Promise<AxiosResponse<PaginationResponse<DistributionRegionResponse>>>{
    return api.get(`${baseRoute}/Search`, {params: request})
  }

  saveRegion(request: DistributionRegionSaveRequest): Promise<AxiosResponse<Result<DistributionRegionResponse>>> {
    return api.post(`${baseRoute}`, request);
  }

  delete(guidRegion: string) : Promise<AxiosResponse<Result<unknown>>>{
    return api.delete(`${baseRoute}/Delete`, {params:  { guidRegion }})
  }
}
